<wiz-hgroup height="100%" width="100%" verticalAlign="center" style="padding-left: 5px" gap="10">
  <wiz-hgroup width="120px" height="100%"  horizontalAlign="end"
   style="border-right-style: solid;border-width: 1px; border-color: var(--grid-border-color);" style="padding: 2px">
    <wiz-label [wizLabel]="data.r"></wiz-label>
  </wiz-hgroup>
  <wiz-hgroup height="100%" width="100%"  style="padding: 2px">
    <wiz-label [wizLabel]="data.l" width="100%"></wiz-label>
  </wiz-hgroup>
</wiz-hgroup>
